import { Meta, StoryObj } from "@storybook/nextjs-vite";
import { IntegrationCard } from "./IntegrationCard";

const meta: Meta<typeof IntegrationCard> = {
  title: "Integration card",
  component: IntegrationCard,
  decorators: [
    (Story) => (
      <div className="mx-auto max-w-lg">
        <Story />
      </div>
    ),
  ],
  args: {
    type: "Integration",
    title: "Title",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ligula tortor, varius in elementum malesuada, placerat nec sem. Nullam tempus enim orci, eget imperdiet nisl aliquet ut. Nunc quis egestas mauris, eu accumsan arcu. Ut fermentum, sapien eu sagittis faucibus, tellus nunc lobortis augue, nec tincidunt ante neque non urna.",
    link: {
      title: "Link",
      url: "#",
      dld: "dld",
      dlt: "dlt",
    },
    media: {
      type: "image",
      image:
        "https://p1.aprimocdn.net/solarwinds/fe7b05e6-0071-4571-a052-b2f1016afa54/Placeholder_image_Original%20file.png?disable=upscale&width=1024",
    },
  },
};

export default meta;

export const White: StoryObj<typeof IntegrationCard> = {
  globals: {
    backgrounds: {
      value: "white",
    },
  },
  render: (args) => (
    <section data-theme="white">
      <IntegrationCard {...args} />
    </section>
  ),
};

export const Gray: StoryObj<typeof IntegrationCard> = {
  globals: {
    backgrounds: {
      value: "gray",
    },
  },
  render: (args) => (
    <section data-theme="gray">
      <IntegrationCard {...args} />
    </section>
  ),
};

export const Black: StoryObj<typeof IntegrationCard> = {
  globals: {
    backgrounds: {
      value: "black",
    },
  },
  render: (args) => (
    <section data-theme="black">
      <IntegrationCard {...args} />
    </section>
  ),
};
